import * as action_types from "./constants";

const initialState = {
  GET_USERS: {
    count: 0,
    result: [],
  },
  GET_ACL_GROUPS: {
    count: 0,
    result: [],
  },
};
export default (state = initialState, action) => {
  const { type, data } = action;
  switch (type) {
    case action_types.GET_USERS:
      return { ...state, userList: data };
    case action_types.GET_ACL_GROUPS:
      return { ...state, aclGroupList: data };
    default:
      return state;
  }
};
